import React from 'react';
import App from './App';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from "@unicred/uds-core";

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);